import { GetProductsByIdBatchedQuery } from 'packages/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

export const GTM_LIST_LABEL = 'gift_sets';

interface TrackElementClickArgs {
  timing: number;
  name: string;
  type: string;
  action: string;
  interaction?: string;
}

export const trackElementClick = ({
  action,
  name,
  timing,
  type,
  interaction = 'click',
}: TrackElementClickArgs) => {
  dispatchTrackingEvent({
    event: 'element_click',
    _clear: true,
    element: {
      timing,
      interaction,
      name,
      type,
      action,
    },
  });
};

export const trackAvailableSets = (
  products: GetProductsByIdBatchedQuery['vpProductByIds'],
  productIds: string[],
  interaction: 'scroll' | 'click'
) => {
  const transformedProducts = products.map((product) =>
    ProductEventWither()
      .withVpProduct(product)
      .withAdditionalData({
        list_position: productIds.findIndex((id) => id === product.id) + 1,
      })
      .build()
  );

  dispatchTrackingEvent({
    event: 'view_item_list',
    _clear: true,
    product_lists: {
      list_name: GTM_LIST_LABEL,
      interaction,
      sorting_type: 'automatic',
      products: transformedProducts,
    },
  });
};
